import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import getConfig from "~/config";
import { getState } from "~/globalStore";

let {version} = getConfig();

const apiKey = String(process.env.ENABLE_REPORTING) === "false" ? null : process.env.VB_ADMIN_BUG_TRACKER_API_KEY;
if(apiKey) {
    Bugsnag.start({
        apiKey,
        appVersion: version,
        releaseStage: process.env.NODE_ENV || "development",
        plugins: [new BugsnagPluginReact()],
        enabledReleaseStages: [ 'production'],
        enabledBreadcrumbTypes: ['error', 'navigation', 'request', 'user'],
        onError: function(event) {
            event.addMetadata('store', getState())
        },
        redactedKeys: [
            /^password$/i,
            "token"
        ]
    })
}

export const reportError = (error) => {
    if (!apiKey) return;
    Bugsnag.notify(error);
}